// extracted by mini-css-extract-plugin
module.exports = {"weeksSlider":"WeeksSlider_weeksSlider__1gGzk","weeks":"WeeksSlider_weeks__1Gt-9","weekBar":"WeeksSlider_weekBar__1_4bW"};